import PropTypes from 'prop-types';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const RememberMeCheckbox = ({
  onChange,
  checked,
  disabled
}) => {
  return /*#__PURE__*/_jsx(Checkbox, {
    "data-test-id": "remember-me",
    id: "remember",
    checked: checked,
    onChange: onChange,
    disabled: disabled,
    marginBlockEnd: "400",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "login.form.remember"
    })
  });
};
RememberMeCheckbox.propTypes = {
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired
};
export default RememberMeCheckbox;